import React from 'react';
import { Colors } from "../../constants/Consts";
import { SectorBasisChoices } from "../../constants/types";

const SectorItem: React.FC<SectorBasisChoices & { isSelected: boolean, onSelect: (id: number) => void }> = ({ 
    sectorId, 
    xSvgData, 
    ySvgData, 
    svgData, 
    isSelected, 
    onSelect, 
    newestSector, 
    oldestSector,
    hierarchy,
    isSelectionnable
}) => {
    
    const handlePress = () => {
        if (isSelectionnable) {
            onSelect(sectorId);
        }
    };

    if (!svgData) return null;

    // Helper to recursively render SVG elements
    const renderSvgElement = (node: any, key: string | number) => {
        if (!node) return null;

        const { tag, attributes, children } = node;
        // Remove namespace if present
        const tagName = tag.replace('{http://www.w3.org/2000/svg}', '');
        
        let elementProps = { ...attributes, key };

        // Handle fill color logic for paths
        if (tagName === 'path') {
             // Logic to override fill color based on state
             // We target the default color "#9E30FF" or similar if we want to replace the "main" color
             const targetColor = "#9E30FF"; 
             
             let fillColor = attributes.fill;

             if (attributes.fill === targetColor) {
                 if (isSelected) {
                     fillColor = Colors.colorprimary400;
                 } else if (newestSector) {
                     fillColor = Colors.colorsecondary400;
                 } else if (oldestSector) {
                     fillColor = Colors.colorred400;
                 }
             }
             
             // If the fill was not targetColor, we leave it (e.g. if it's white or part of a filter/shadow)
             // However, checking the user's previous code, index 0 was transparent. 
             // If the new SVG has a background path, it might need handling.
             // But relying on color matching is more robust for general SVGs than index.

             elementProps.fill = fillColor;
        }

        const renderedChildren = children?.map((child: any, index: number) => 
            renderSvgElement(child, index)
        );

        return React.createElement(tagName, elementProps, renderedChildren);
    };

    const { attributes, children } = svgData;
    // Use attributes from the root of svgData, defaulting if necessary
    const width = attributes?.width || 0;
    const height = attributes?.height || 0;
    const viewBox = attributes?.viewBox || `0 0 ${width} ${height}`;

    // Filter out width/height/viewBox from spread attributes to avoid duplication/conflict if passed explicitly
    const { width: _w, height: _h, viewBox: _vb, ...otherAttributes } = attributes || {};

    return (
        <svg 
            width={width} 
            height={height} 
            viewBox={viewBox} 
            style={{
                position: 'absolute',
                left: xSvgData,
                top: ySvgData,
                cursor: isSelectionnable ? 'pointer' : 'default',
                zIndex: (hierarchy || 0) + 1
            }}
            onClick={handlePress}
            {...otherAttributes}
        >
            {children?.map((child: any, index: number) => 
                renderSvgElement(child, index)
            )}
        </svg>
    );
};

export default SectorItem;
